var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 795"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 90",
    d: "M5.5 12L13.5 12L9.5 7L5.5 12Z",
    fill: "#444444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpSquare);
export default __webpack_public_path__ + "static/media/arrow-up-square.5c1c26c2f0660d824f6e182a4758aa87.svg";
export { ForwardRef as ReactComponent };